// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GiftcardSearchResponse

import { hydrateGiftcard, type Giftcard, type GiftcardApiResponse } from './giftcard.gen';

export type GiftcardSearchApiResponse = {
	items: GiftcardApiResponse[];
};

export type GiftcardSearch = {
	items: Giftcard[];
};

export function hydrateGiftcardSearch(data: GiftcardSearchApiResponse): GiftcardSearch {
	return {
		...data,
		items: data.items.map(hydrateGiftcard),
	};
}